<template>
	<div class="socials-tab">
    <div class="socials-wrapper" :class="{'show': showTabs}">
      <div class="social fb"><a href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fveki.pl%2Fsklep%2F&t=SKLEP"><font-awesome-icon :icon="['fab', 'facebook-f']"/></a></div>
      <div class="social tt"><a href="https://twitter.com/share?text=SKLEP&url=https%3A%2F%2Fveki.pl%2Fsklep%2F&via=veki"><font-awesome-icon :icon="['fab', 'twitter']"/></a></div>
      <div class="social gp"><a href="https://plus.google.com/share?url=https%3A%2F%2Fveki.pl%2Fsklep%2F&t=SKLEP"><font-awesome-icon :icon="['fab', 'google-plus-g']"/></a></div>
      <div class="social pn"><a href="https://pl.pinterest.com/zbigniewowsiak5/pins/"><font-awesome-icon :icon="['fab', 'pinterest-p']"/></a></div>
      <div class="social-toggle"><button @click="toggleTabs"><font-awesome-icon :icon="['fas', 'angle-right']"/></button></div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
  name: 'socials',
  components: {
    VueCookies
  },
  data() {
    return {
      showTabs: true
    }
  },
  mounted() {
    const sv = VueCookies.get('socials-visible');
    if (sv !== null) {
      if (sv === 'true') {
        this.showTabs = true;
      } else {
        this.showTabs = false;
      }
    };
  },
  methods: {
    toggleTabs() {
      this.showTabs = !this.showTabs;
      VueCookies.set('socials-visible', this.showTabs, '30d');
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~$scss/components/socials-tab';
</style>